import React from 'react';

import config from '../../config';
import FormGroup from '../helpers/FormGroup';
import BaseSelect from '../helpers/Select';
import BaseInput from '../helpers/Input';
import { getIn } from '../../utils/ChangeSpy';
import PrettyError from '../decorators/PrettyError';
import DisplayError from '../decorators/DisplayError';

const Select = PrettyError(DisplayError(BaseSelect));
const Input = PrettyError(DisplayError(BaseInput));

const types = config.values.get('companyTypes');
const tickerExchanges = config.values.getIn(['company', 'tickerExchange']);

const EmptyTicker = () => null;

const Ticker = props => (
  <div className="row">
    <FormGroup className="col-md-6">
      <Select
        defaultText=" "
        label="Exchange"
        name={props.exchangeName}
        onChange={props.onChange}
        options={tickerExchanges}
        root={props.company}
        deep
        showLabel
      />
    </FormGroup>
    <FormGroup className="col-md-6">
      <Input
        label="Symbol"
        name={props.symbolName}
        onChange={props.onChange}
        placeholder=""
        root={props.company}
        deep
        showLabel
      />
    </FormGroup>
  </div>
);

export const hasTickerExchange = company => {
  const currentType = getIn(company, 'companyType') || getIn(company, 'entityType');

  return types.some(type => type.get('value') === currentType && type.get('hasTicker'));
};

export const getTickerExchange = company => {
  if (!hasTickerExchange(company)) return EmptyTicker;

  return Ticker;
};
